/** Language catalog. Mirrors engine/interligne/languages.py; refreshed from /engine/languages. */

export type Language = { code: string; name: string; native: string; tested: boolean };

export const AUTO = "auto";

export const FALLBACK_LANGUAGES: Language[] = [
  ["ar", "Arabic", "العربية"],
  ["bn", "Bengali", "বাংলা"],
  ["ca", "Catalan", "Català"],
  ["cs", "Czech", "Čeština"],
  ["da", "Danish", "Dansk"],
  ["de", "German", "Deutsch"],
  ["el", "Greek", "Ελληνικά"],
  ["en", "English", "English"],
  ["es", "Spanish", "Español"],
  ["fa", "Persian", "فارسی"],
  ["fi", "Finnish", "Suomi"],
  ["fr", "French", "Français"],
  ["he", "Hebrew", "עברית"],
  ["hi", "Hindi", "हिन्दी"],
  ["hu", "Hungarian", "Magyar"],
  ["id", "Indonesian", "Bahasa Indonesia"],
  ["it", "Italian", "Italiano"],
  ["ja", "Japanese", "日本語"],
  ["ko", "Korean", "한국어"],
  ["ms", "Malay", "Bahasa Melayu"],
  ["nl", "Dutch", "Nederlands"],
  ["no", "Norwegian", "Norsk"],
  ["pl", "Polish", "Polski"],
  ["pt", "Portuguese", "Português"],
  ["ro", "Romanian", "Română"],
  ["ru", "Russian", "Русский"],
  ["sv", "Swedish", "Svenska"],
  ["sw", "Swahili", "Kiswahili"],
  ["ta", "Tamil", "தமிழ்"],
  ["th", "Thai", "ไทย"],
  ["tl", "Tagalog", "Tagalog"],
  ["tr", "Turkish", "Türkçe"],
  ["uk", "Ukrainian", "Українська"],
  ["ur", "Urdu", "اردو"],
  ["vi", "Vietnamese", "Tiếng Việt"],
  ["zh", "Chinese", "中文"],
].map(([code, name, native]) => ({ code: code!, name: name!, native: native!, tested: code === "en" || code === "fr" }));

export function languageName(list: Language[], code: string): string {
  if (code === AUTO) return "Auto-detect";
  if (code === "und") return "Unknown";
  return list.find((l) => l.code === code)?.name ?? code.toUpperCase();
}

/** BCP-47-ish tag for speechSynthesis voices and the `lang` attribute. */
export function speechTag(code: string): string {
  return code === "no" ? "nb" : code === "tl" ? "fil" : code;
}

const RTL = new Set(["ar", "fa", "he", "ur"]);
export function isRtl(code: string): boolean {
  return RTL.has(code);
}
